// extracted by mini-css-extract-plugin
export default {"app":"app__AcVfV"};